import { SKIN_TONES } from './skin-tones.js';
export const defaultColors = Object.freeze({
    skinTone: SKIN_TONES.light,
    primaryBackgroundColor: '#fff',
    primaryDataColor: '#2f3d46',
    primaryAccentColor: '#30A8F2',
    secondaryDataColor: '#566a75',
    contourColor: '#d5dddf',
    secondaryBackgroundColor: '#f6f6f6',
    errorColor: '#e53b3b',
    confirmationColor: '#79c926',
    secondaryAccentColor: '#fa9256',
    blueGradient: 'linear-gradient(226deg, #49ace9, #4980e9)',
    orangeGradient: 'linear-gradient(284deg, #ff9c23, #f86068)'
});
export const skillsetColors = Object.freeze({
    ...defaultColors,
    contourColor: '#D9E3EB',
    primaryDataColor: '#254C64',
    secondaryDataColor: '#417292',
    errorColor: '#E45050',
    confirmationColor: '#68C699'
});
//# sourceMappingURL=colors.js.map